import { handleActions } from "redux-actions";
import { token } from "../actions/firebase";

const defaultState = { fcmToken: undefined };

export const selector = ({ firebase }) => (firebase);

const firebaseReducer = handleActions(
  {
    [token]: (state, { payload }) => ({
      ...state,
      fcmToken: payload.fcmToken,
    }),
  },
  defaultState,
);

export default firebaseReducer;
